export default __webpack_public_path__ + "static/media/straightLeg.3be1101e.png";